<template>
  <abk-offers-list offers-type="all"/>
</template>

<script>
import AbkOffersList from '../../components/offers/AbkOffersList'

export default {
  name: 'OffersList',
  components: { AbkOffersList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.offers.offers_list.title'),
        subtitle: this.$t('views.offers.offers_list.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
</style>
